const {
  hasOwnProperty
} = Object.prototype;
/**
 * obj是否有key属性，不检测原型
 * @param obj
 * @param key
 * @returns
 */
export function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}
//# sourceMappingURL=hasOwn.js.map
